module.exports = __webpack_public_path__ + "fonts/icomoon.1493c87c.woff2";